import Resource from '@/plugins/sdk/Resource'
import { STRING, DATETIME, UUID, ITEM } from '@/plugins/sdk/fields'
import Pickup from '@/plugins/sdk/resources/Pickup'
import Profile from '@/plugins/sdk/resources/Profile'

export const TYPE_AUTOBOOK = 'autobook'
export const TYPE_CREATED = 'created'
export const TYPE_MODIFIED = 'modified'
export const TYPE_CONFIRMED = 'confirmed'
export const TYPE_CLONED = 'cloned'
export const TYPE_HELD = 'held'
export const TYPE_CANCELLED = 'cancelled'
export const TYPE_PROCESSED = 'processed'
export const TYPE_HIDDEN = 'hidden'
export const TYPE_ERROR = 'error'

export default class extends Resource {
  static name = 'pickup_event'

  static get fields () {
    return {
      id: new UUID(),
      type: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      pickup: new ITEM(Pickup),
      profile: new ITEM(Profile)
    }
  }
}
